var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "unit_group" },
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "div",
        {
          directives: [
            { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
          ],
          key: index,
          attrs: { label: "" },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: 4,
                  expression: "4",
                },
              ],
            },
            [
              _c("div", { staticStyle: { display: "flex", height: "80%" } }, [
                _c("label", { staticStyle: { "align-self": "flex-end" } }, [
                  _vm._v(" " + _vm._s(_vm.$t(item.title)) + " "),
                ]),
              ]),
            ]
          ),
          _c("div", {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: 1,
                expression: "1",
              },
            ],
          }),
          _c(
            "pui-form-group",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: 3,
                  expression: "3",
                },
              ],
              staticStyle: { margin: "auto" },
              attrs: {
                label: index === 0 ? "MWh" : "",
                "has-label-padding": false,
              },
            },
            [
              _c("custom-input", {
                attrs: {
                  "is-disabled": !_vm.isEditable,
                  required: true,
                  precision: _vm.unavailabilityPrecision,
                  min: _vm.min,
                },
                on: {
                  change: function ($event) {
                    return _vm.onInputChange(item)
                  },
                },
                model: {
                  value: item.MWh,
                  callback: function ($$v) {
                    _vm.$set(item, "MWh", $$v)
                  },
                  expression: "item.MWh",
                },
              }),
            ],
            1
          ),
          _c(
            "pui-form-group",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: 3,
                  expression: "3",
                },
              ],
              staticClass: "center-l",
              attrs: {
                label: index === 0 ? "%" : "",
                "has-label-padding": false,
              },
            },
            [
              _c("custom-input", {
                attrs: {
                  "is-disabled": true,
                  precision: _vm.unavailabilityPrecision,
                },
                model: {
                  value: item.percentage,
                  callback: function ($$v) {
                    _vm.$set(item, "percentage", $$v)
                  },
                  expression: "item.percentage",
                },
              }),
            ],
            1
          ),
          _c("div", {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: 1,
                expression: "1",
              },
            ],
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }